import React, { useState } from "react";
import BigLogo from '../assets/images/newlogo.png';
import ProductsOld from "../pages/Products";
import { Link } from "react-router-dom";
import GeoMap from "../../src/pages/geo/GeoMap";
import Home from "../pages/home/Home";
import { useLanguage } from "./hooks/LanguageContext";
import AppProps from "../static/js/AppProps";

const Footer = () => {
    const [pdfToShow, setPdfToShow] = useState(null);
    const { language, toggleLanguage } = useLanguage();

    const texts = {
        ru: {
            wisdomTitle: "Народная мудрость",
            wisdomText: `Аналитика — не шутка,
Тут важна не только чуйка.
GeoSurf волну поймает —
Там, где бизнес процветает!`,
            helpTitle: "Помощь",
            helpLinks: [
                { to: Home.link, text: "Главная" },
                { to: ProductsOld.link, text: "Товары" },
                { to: GeoMap.link, text: "Демо карта" }
            ],
            contactsTitle: "Контакты",
            phoneText: "Телефон: ",
            phone: "+7 996-910-33-17",
            emailText: "Email: ",
            email: "geosurf.info@gmail.com",
            policyText: "Политикой обработки персональных данных",
            agreementText: "Пользовательским соглашением"
            // supportText удалён
        },
        en: {
            wisdomTitle: "Industry Wisdom",
            wisdomText: `Analytics is no game,
Instinct alone won’t bring you fame.
GeoSurf catches the wave just right,
Where business blooms in plain sight!`,
            helpTitle: "Support",
            helpLinks: [
                { to: Home.link, text: language === 'ru' ? "Главная" : "Home" },
                { to: ProductsOld.link, text: language === 'ru' ? "Товары" : "Products" },
                { to: GeoMap.link, text: language === 'ru' ? "Карта" : "Map" }
            ],
            contactsTitle: "Contact",
            phoneText: "Phone: ",
            phone: "+7 996-910-33-17",
            emailText: "Email: ",
            email: "geosurf.info@gmail.com",
            policyText: "Privacy Policy",
            agreementText: "Terms of Service"
            // supportText удалён
        }
    };

    const t = texts[language];

    const fetchAndOpenPdf = async (endpointName) => {
        try {
            const url = `${AppProps.spring_server_url}/document/${endpointName}`;
            const response = await fetch(url);
            if (!response.ok) throw new Error('Не удалось загрузить файл');
            const blob = await response.blob();
            if (blob.type !== 'application/pdf') throw new Error('Файл не в формате PDF');
            setPdfToShow(URL.createObjectURL(blob));
        } catch (error) {
            console.error("Ошибка при загрузке PDF:", error);
            alert(error.message || "Не удалось загрузить документ.");
        }
    };

    const closePdfModal = () => setPdfToShow(null);

    return (
        <>
            <section data-bs-version="5.1" className="footer4 cid-uHqL79eomx" id="footer">
                <div className="container">
                    <div className="row mbr-white">

                        {/* Wisdom */}
                        <div className="col-12 col-md-6 col-lg-3">
                            <h5 className="mbr-section-subtitle mbr-fonts-style mb-2 display-7">
                                <strong>{t.wisdomTitle}</strong>
                            </h5>
                            <p className="mbr-text mbr-fonts-style mb-4 display-4">
                                {t.wisdomText.split('\n').map((line, i) => <span key={i}>{line}<br/></span>)}
                            </p>
                        </div>

                        {/* Support Links */}
                        <div className="col-12 col-md-6 col-lg-3">
                            <h5 className="mbr-section-subtitle mbr-fonts-style mb-2 display-7">
                                <strong>{t.helpTitle}</strong>
                            </h5>
                            <ul className="list mbr-fonts-style display-4 col-12 col-ld-3">
                                {t.helpLinks.map((link, i) => (
                                    <li key={i}>
                                        <Link className="mbr-text item-wrap mb-4" to={link.to}>{link.text}</Link>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Contacts */}
                        <div className="col-12 col-md-6 col-lg-3">
                            <h5 className="mbr-section-subtitle mbr-fonts-style mb-2 display-7">
                                <strong>{t.contactsTitle}</strong>
                            </h5>
                            <ul className="list mbr-fonts-style display-7">
                                <li className="mbr-text item-wrap">{t.emailText}<a href={`mailto:${t.email}`}>{t.email}</a></li>
                            </ul>
                        </div>

                        {/* Logo, Language & Social */}
                        <div className="col-6 col-lg-3 d-flex flex-column align-items-center">
                            <a href={Home.link} style={{maxWidth:'150px', width:'100%'}}>
                                <img src={BigLogo} alt="logo" style={{maxWidth:'150px', height:'auto', display:'block'}}/>
                            </a>

                            <div className="social-row display-7 mt-3 d-flex justify-content-center w-100">
                                <a href="https://t.me/geosurfru" target="_blank" rel="noreferrer" className="mx-2">
                                    <span className="mbr-iconfont socicon-telegram socicon"></span>
                                </a>
                                <a href="https://www.linkedin.com/company/geosurfglobal" target="_blank" rel="noreferrer" className="mx-2">
                                    <span className="mbr-iconfont socicon-linkedin socicon"></span>
                                </a>
                            </div>
                        </div>
                    </div>

                    {/*/!* Company & Agreements – блок с поддержкой удалён *!/*/}
                    {/*<div className="col-12 mt-4">*/}
                    {/*    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">*/}
                    {/*        <div className="mb-3" style={{maxWidth:'100%', flex:1}}>*/}
                    {/*            <p className="mbr-text-info mb-0 mbr-fonts-style copyright align-left display-7">*/}
                    {/*                ОГРН 1246200004852<br/>*/}
                    {/*                ИНН 6200006113<br/>*/}
                    {/*                ООО "ГЕОСЁРФ ГЛОБАЛ"<br/>*/}
                    {/*                geosurf.info@gmail.com<br/>*/}
                    {/*                390027, г. Рязань, ул Кальная, д. 7, кв. 119*/}
                    {/*            </p>*/}

                    {/*            <p className="mbr-text-info mb-0 mt-3 mbr-fonts-style copyright align-left display-7">*/}
                    {/*                Находясь на сайте, вы соглашаетесь с{' '}*/}
                    {/*                <span*/}
                    {/*                    role="button"*/}
                    {/*                    className="link mbr-fonts-style text-primary display-7"*/}
                    {/*                    style={{ cursor:'pointer', textDecoration:'underline', marginRight:'15px' }}*/}
                    {/*                    onClick={() => fetchAndOpenPdf('privacy_policy.pdf')}*/}
                    {/*                >*/}
                    {/*                    {t.policyText},*/}
                    {/*                </span>*/}
                    {/*                <span*/}
                    {/*                    role="button"*/}
                    {/*                    className="link mbr-fonts-style text-primary display-7"*/}
                    {/*                    style={{ cursor:'pointer', textDecoration:'underline' }}*/}
                    {/*                    onClick={() => fetchAndOpenPdf('user_agreement.pdf')}*/}
                    {/*                >*/}
                    {/*                    {t.agreementText}*/}
                    {/*                </span>*/}
                    {/*            </p>*/}
                    {/*        </div>*/}

                    {/*        /!* Блок с поддержкой и картинкой полностью удалён *!/*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                </div>
            </section>

            {pdfToShow && (
                <div className="modal show d-block" tabIndex="-1" style={{backgroundColor:"rgba(0,0,0,0.5)"}} onClick={closePdfModal}>
                    <div className="modal-dialog modal-xl" onClick={e => e.stopPropagation()}>
                        <div className="modal-content" style={{height:'90vh', display:'flex', flexDirection:'column'}}>
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    {pdfToShow.includes('privacy_policy') ? t.policyText : t.agreementText}
                                </h5>
                                <button type="button" className="btn-close" onClick={closePdfModal}></button>
                            </div>
                            <div className="modal-body" style={{flex:1, padding:0, overflow:'hidden'}}>
                                <iframe src={pdfToShow} title="PDF Document" width="100%" height="100%" style={{border:'none'}} />
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={closePdfModal}>Закрыть</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Footer;